import { GMNMonitoringPointTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGmnLibraryFields } from "../../../schema/gmn-schema-library";

export const getGmnMeasuringPointSchema = (
  type: FormType | undefined
): SchemaForFormData<GMNMonitoringPointTask> => ({
  type: "object",
  title: `GMN-Meetpunt ${getTitleAddon(type)}`,
  description: `Dit is het GMN Meetpunt formulier. Upload een Excel bestand met meetpunten. ${getDocsLinkMarkdown(
    "GMN"
  )}`,
  required: ["metadata", "measuringPointsFile"],
  properties: {
    metadata: {
      type: "object",
      required: ["projectNumber", "broId", "qualityRegime", "deliveryAccountableParty"],
      properties: pickGmnLibraryFields([
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
      ]),
    },
    ...pickGmnLibraryFields(["measuringPointsFile"]),
  },
});
